import { IRect, Vector2d } from "konva/lib/types";
import { ALTEZZA_FINESTRA, ALTEZZA_FINESTRA_ACCIAIO, ALTEZZA_GRIGLIA, ALTEZZA_GRIGLIA_ALLUMINIO, DISTANZA_MINIMA_FINESTRA_GRIGLIA, LARGHEZZA_FINESTRA, LARGHEZZA_FINESTRA_ACCIAIO, LARGHEZZA_GRIGLIA, LARGHEZZA_GRIGLIA_ALLUMINIO, LARGHEZZA_PORTINA_INT_1200, LARGHEZZA_PORTINA_INT_900, SPESSORE_STIPITE } from "../../../../../../core/common_constants";
import { InstallationType, NullableString } from "../../../../../../core/common_types";
import { GridSize, IntegratedDoorConfiguration, WindowSize } from "../../../../../../models/door_configuration";
import { DatiPannello } from "../../../../../../core/common_draw_types";
import { distance, toDrawUnit } from "../../../../../../core/common_functions";
import { Vector } from "vecti";
import rals from "../../../../../../assets/rals.json";

export type PlaceholderRect = IRect & { position: number };

function invertiColoreHex(hex: string) {
  // 1. Rimuove il cancelletto se presente
  hex = hex.replace('#', '');

  // 2. Gestisce i formati brevi a 3 cifre (es. #03F -> #0033FF)
  if (hex.length === 3) {
    hex = hex.split('').map(char => char + char).join('');
  }

  // 3. Converte in numeri interi (Base 16)
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  // 4. Calcola il negativo e riconverte in Hex
  const rInv = (255 - r).toString(16).padStart(2, '0');
  const gInv = (255 - g).toString(16).padStart(2, '0');
  const bInv = (255 - b).toString(16).padStart(2, '0');
  console.log("INVERSO",`#${rInv}${gInv}${bInv}`.toUpperCase())
  return `#${rInv}${gInv}${bInv}`.toUpperCase();
}

export function getStrokeColor(colorCode: NullableString): string {
    if (!colorCode) return "#000000";
    const ral = rals.find(r => r.RAL === colorCode);
    if (!ral) return "#000000";
    return invertiColoreHex(ral.HEX);
}

export function calcolaNumeroFinestreDaLarghezzaPorta(larghezzaPorta: number): number {
    let res = 2;
    if (larghezzaPorta > 2410 && larghezzaPorta <= 3150) {
        res = 3;
    } else if (larghezzaPorta > 3150 && larghezzaPorta <= 3890) {
        res = 4;
    } else if (larghezzaPorta > 3890 && larghezzaPorta <= 4630) {
        res = 5;
    } else if (larghezzaPorta > 4630 && larghezzaPorta <= 5370) {
        res = 6;
    } else if (larghezzaPorta > 5370 && larghezzaPorta <= 6000) {
        res = 7;
    }
    return res;
}

export function calcolaNumeroGriglieDaLarghezzaPorta(larghezzaPorta: number): number {
    let res = 3;
    if (larghezzaPorta > 2590 && larghezzaPorta <= 3190) {
        res = 4;
    } else if (larghezzaPorta > 3190 && larghezzaPorta <= 3790) {
        res = 5;
    } else if (larghezzaPorta > 3790 && larghezzaPorta <= 4390) {
        res = 6;
    } else if (larghezzaPorta > 4390 && larghezzaPorta <= 4990) {
        res = 7;
    } else if (larghezzaPorta > 4990 && larghezzaPorta <= 5590) {
        res = 8;
    } else if (larghezzaPorta > 5590 && larghezzaPorta <= 6000) {
        res = 9;
    }
    return res;
}

export function calcolaFinestreDaNumeroElementi(numeroElementi: number, panelData: DatiPannello, windowSize: WindowSize): PlaceholderRect[] {
    let res: PlaceholderRect[] = [];
    
    let larghezzaFinestra = windowSize == WindowSize._230x230 ? LARGHEZZA_FINESTRA_ACCIAIO : LARGHEZZA_FINESTRA;
    let altezzaFinestra = windowSize == WindowSize._230x230 ? ALTEZZA_FINESTRA_ACCIAIO : ALTEZZA_FINESTRA;

    const ar = altezzaFinestra/larghezzaFinestra;
    altezzaFinestra = altezzaFinestra * panelData.bbox.height / panelData.altezzaAssoluta;
    larghezzaFinestra = altezzaFinestra / ar;

    let lunghezzaMax = panelData.bbox.width - (2 * DISTANZA_MINIMA_FINESTRA_GRIGLIA) - larghezzaFinestra;
    let interasse = lunghezzaMax / (numeroElementi - 1);

    let currentX: number = DISTANZA_MINIMA_FINESTRA_GRIGLIA;
    for (let i = 0; i < numeroElementi; i++) {
        res.push({
            x: currentX,
            y: 0,
            width: larghezzaFinestra,
            height: altezzaFinestra,
            position: i
        }); 

        currentX = currentX + interasse;
    }

    return res;
}

export function calcolaGriglieDaNumeroElementi(numeroElementi: number, panelData: DatiPannello, gridSize: GridSize): PlaceholderRect[] {
    let res: PlaceholderRect[] = [];

    let larghezzaGriglia = gridSize == GridSize._400x200 ? LARGHEZZA_GRIGLIA_ALLUMINIO : LARGHEZZA_GRIGLIA;
    let altezzaGriglie = gridSize == GridSize._400x200 ? ALTEZZA_GRIGLIA_ALLUMINIO : ALTEZZA_GRIGLIA;

    const ar = altezzaGriglie/larghezzaGriglia;
    altezzaGriglie = altezzaGriglie * panelData.bbox.height / panelData.altezzaAssoluta;
    larghezzaGriglia = altezzaGriglie / ar;

    let lunghezzaMax = panelData.bbox.width - (2 * DISTANZA_MINIMA_FINESTRA_GRIGLIA) - larghezzaGriglia;
    let interasse = lunghezzaMax / (numeroElementi - 1);

    let currentX: number = DISTANZA_MINIMA_FINESTRA_GRIGLIA;
    for (let i = 0; i < numeroElementi; i++) {
        res.push({
            x: currentX,
            y: 0,
            width: larghezzaGriglia,
            height: altezzaGriglie,
            position: i
        }); 

        currentX = currentX + interasse;
    }

    return res;
}

export function buildBoundingBoxPortina(
    larghezzaForo: number, 
    altezzaForo: number, 
    isOltreLuce: boolean, 
    tipoInstallazioneMontanteDx: InstallationType, 
    tipoInstallazioneMontanteSx: InstallationType, 
    datiPortina: IntegratedDoorConfiguration
): IRect {
    const lf = toDrawUnit(larghezzaForo);
    const hf = toDrawUnit(altezzaForo);
    const pf = Vector.of([lf/2, hf/2]);

    let larghezzaDefault: number = 0;        
    if (datiPortina.fuoriMisura == "900") {
        larghezzaDefault = LARGHEZZA_PORTINA_INT_900;
    } else if (datiPortina.fuoriMisura == "1200") {
        larghezzaDefault = LARGHEZZA_PORTINA_INT_1200;
    } else {
        larghezzaDefault = toDrawUnit(datiPortina.larghezza?.esternoTelaio ?? 0);
    }

    let org = Vector.of([(lf / 2), hf]);
    
    if (datiPortina.posizione == "sx") {
        org = Vector.of([(larghezzaDefault/2) + 50, hf]);
    } else if (datiPortina.posizione == "dx") {
        org = Vector.of([lf-(larghezzaDefault/2) - 50, hf]);
    }

    let altezzaPortina = toDrawUnit(datiPortina.altezza?.esternoTelaio ?? 0);
    let altezzaSoglia = datiPortina.soglia?.rialzata ? toDrawUnit(datiPortina.soglia?.altezza ?? 0) : 0;
    let larghezzaPortina = larghezzaDefault;
    
    if (!isOltreLuce) {    
        altezzaPortina -= altezzaSoglia;
    } else {
        altezzaPortina -= altezzaSoglia;
        
        if (tipoInstallazioneMontanteDx == InstallationType.oltre_luce &&
            tipoInstallazioneMontanteSx == InstallationType.in_luce) {        
            org = Vector.of([org.x - (10/2), org.y]);
        } else if (tipoInstallazioneMontanteSx == InstallationType.oltre_luce &&
            tipoInstallazioneMontanteDx == InstallationType.in_luce) {
            org = Vector.of([org.x + (10/2), org.y]);
        } else {
            
        }
        // let dir = pf.subtract(org).normalize();
        // let newOrg = org.add(dir.multiply(SPESSORE_STIPITE));

        // let psx = Vector.of([0, hf]);
        // dir = pf.subtract(psx).normalize();
        // psx = psx.add(dir.multiply(SPESSORE_STIPITE));

        // org = Vector.of([newOrg.x, psx.y]);    
            
        // let psxT = Vector.of([0, hf-altezzaPortina]);
        // dir = pf.subtract(psxT).normalize();
        // psxT = psxT.add(dir.multiply(SPESSORE_STIPITE));

        // let psxB = Vector.of([0, hf]);//senza soglia
        // dir = pf.subtract(psxB).normalize();
        // psxB = psxB.add(dir.multiply(SPESSORE_STIPITE));

        // const altezzaPortinaSenzaSoglia = distance(psxT.x, psxT.y, psxB.x, psxB.y);
        
        // psxB = Vector.of([0, hf-altezzaSoglia]);//con soglia rialzata
        // dir = pf.subtract(psxB).normalize();
        // psxB = psxB.add(dir.multiply(SPESSORE_STIPITE));
        // altezzaPortina = distance(psxT.x, psxT.y, psxB.x, psxB.y);

        // altezzaSoglia = altezzaPortinaSenzaSoglia - altezzaPortina;
        
        // psx = Vector.of([0, hf]);
        // dir = pf.subtract(psx).normalize();
        // psx = psx.add(dir.multiply(SPESSORE_STIPITE));

        // let pdx = Vector.of([larghezzaPortina, hf]);
        // dir = pf.subtract(pdx).normalize();
        // pdx = pdx.add(dir.multiply(SPESSORE_STIPITE));

        // larghezzaPortina = distance(psx.x, psx.y, pdx.x, pdx.y);
    }
    
    return {
        x: org.x - (larghezzaPortina/2),
        y: org.y - altezzaPortina - altezzaSoglia,
        width: larghezzaPortina,
        height: altezzaPortina
    };
}